import { toast as sonnerToast } from "sonner";
import { useToast as useHookToast } from "@/hooks/use-toast";

// Interface for toast params used throughout the application
interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive" | "success";
}

// Wrapper function to adapt Sonner toast API to our application's expected format
// This function is overloaded to accept both string and object parameters
function toast(props: ToastProps): void;
function toast(title: string, description?: string): void;
function toast(propsOrTitle: ToastProps | string, description?: string): void {
  // If first argument is a string, convert to object format
  if (typeof propsOrTitle === 'string') {
    sonnerToast(propsOrTitle, { description });
    return;
  }
  
  // Otherwise, handle as object
  const { title, description: desc, variant } = propsOrTitle;
  
  // If destructive variant, use error toast
  if (variant === "destructive") {
    sonnerToast.error(title, {
      description: desc
    });
    return;
  }
  
  // If success variant, use success toast
  if (variant === "success") {
    sonnerToast.success(title, {
      description: desc
    });
    return;
  }
  
  // Default case
  sonnerToast(title || "", {
    description: desc
  });
}

export { useHookToast as useToast, toast };
